import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class RexReadAloudIndexController extends Controller {
  queryParams = ['sort', 'pageNumber', 'perPage']

  @tracked sort = 'first_name'

  @tracked pageNumber = 1

  @tracked perPage = 100
}

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/rex/read-aloud-fluency/index': RexReadAloudIndexController
  }
}
